import React, { useEffect } from 'react';
import { Container, Typography, Box, Link, useTheme } from '@mui/material';

const PrivacyPolicy = () => {
  const theme = useTheme();

  useEffect(() => {
    document.getElementById("year").textContent = new Date().getFullYear();
  }, []);

  const styles = {
    body: {
      margin: 0,
      fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '2rem',
    },
    header: {
      textAlign: 'center',
      marginBottom: '2rem',
    },
    headerImg: {
      maxWidth: '160px',
      height: 'auto',
    },
    h1: {
      fontSize: '2rem',
      marginBottom: '1rem',
      color: theme.palette.primary.main,
      fontWeight: 700,
      textAlign: 'center',
    },
    h3: {
      fontSize: '1.3rem',
      marginTop: '1.5rem',
      marginBottom: '0.7rem',
      color: theme.palette.primary.main,
    },
    p: {
      fontSize: '1.05rem',
      lineHeight: 1.6,
    },
    main: {
      maxWidth: '650px',
      background: theme.palette.background.paper,
      padding: '2rem',
      borderRadius: '8px',
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    },
    ul: {
      marginTop: '0.5rem',
      paddingLeft: '1.5rem',
    },
    footer: {
      marginTop: '3rem',
      fontSize: '0.9rem',
      color: theme.palette.text.secondary,
      textAlign: 'center',
    },
  };

  return (
    <Box sx={styles.body}>
      <header style={styles.header}>
        <img src="https://imagizer.imageshack.com/v2/280x200q70/924/1yx2xL.png" alt="gdscreate automations" style={styles.headerImg} />
        <Typography variant="h1" component="h1" sx={styles.h1}>
          Privacy Policy
        </Typography>
      </header>

      <Box component="main" sx={styles.main}>
        <Typography variant="body1" component="p" sx={{ ...styles.p, fontStyle: 'italic' }} >
          Last updated: August 28, 2025
        </Typography>
        <br />
        <Typography variant="body1" component="p" sx={styles.p}>
          We value your privacy and want to be transparent about the data we access when you use our app.
        </Typography>

        <Typography variant="h3" component="h3" sx={styles.h3}>Information We Access</Typography>
        <ul style={styles.ul}>
          <li><strong>OpenID Connect (openid):</strong> We use this scope to authenticate you securely by accessing your unique user ID.</li>
          <li><strong>Email:</strong> We access your email address to identify your account and communicate important updates.</li>
          <li><strong>Profile:</strong> We access your basic profile information like your name and profile picture to personalize your experience.</li>
          <li><strong>Google Drive File Access (drive.file):</strong> We can access and manage only the Google Drive files that you have created with our app or explicitly opened through it. We do not access other files in your Drive.</li>
        </ul>

        <Typography variant="h3" component="h3" sx={styles.h3}>How We Use Your Data</Typography>
        <Typography variant="body1" component="p" sx={styles.p}>
          Our application does not permanently store any Google user data.
          <br /><br />
          When users connect their Google Drive, our automations create a folder called 'gdscreate-automations' and it creates input files (with data provided by the user) for processing and output files (the results of processing). These files remain entirely within the user’s own Google account.
          <br /><br />
          All processing is performed in real time. No customer data, input, or output is ever copied, stored, or retained on our servers. The application’s architecture has been intentionally designed to avoid storing any user data on our side.
          <br /><br />
          Since no Google user data is retained, there is nothing to delete from our systems. However, users may delete their own input and output files directly within Google Drive or Google Sheets at any time.
          <br /><br />
          We do not share or sell user data under any circumstances.
        </Typography>


        <Typography variant="h3" component="h3" sx={styles.h3}>Security</Typography>
        <Typography variant="body1" component="p" sx={styles.p}>
          We implement industry-standard security measures to protect your data.
        </Typography>

        <Typography variant="h3" component="h3" sx={styles.h3}>Contact Us</Typography>
        <Typography variant="body1" component="p" sx={styles.p}>
          If you have any questions about this Privacy Policy, please contact us at <Link href="https://gdscreate.com" target="_blank" rel="noopener noreferrer">gdscreate.com</Link>.
        </Typography>
      </Box>

      <footer style={styles.footer}>
        &copy; <span id="year"></span> gdscreate. All rights reserved.
      </footer>
    </Box>
  );
};

export default PrivacyPolicy;
